import { render, staticRenderFns } from "./BaskoBoxList.vue?vue&type=template&id=b237d710&"
import script from "./BaskoBoxList.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxList.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxList.vue?vue&type=style&index=0&id=b237d710&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports